var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgQuote = function SvgQuote(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 38 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.521 0v8.195c-2.32.179-4.103.95-5.352 2.316-1.19 1.366-1.784 3.059-1.784 5.078h7.76V31H0V16.836c0-4.75 1.397-8.64 4.192-11.67C7.047 2.139 10.823.417 15.522 0Zm21.765 0v8.195c-2.319.179-4.073.95-5.263 2.316-1.189 1.366-1.784 3.059-1.784 5.078H38V31H21.765V16.836c0-4.75 1.427-8.64 4.282-11.67C28.9 2.139 32.647.417 37.287 0Z",
    fill: "#151515"
  })));
};
export default SvgQuote;